import api, { buildURLWithParams } from '@/services/api';

import type {
  GetRoadmapTempoDTO,
  PostRoadmapMassEditTempoDTO,
  PostRoadmapTempoDTO,
  RoadmapParticipantDeletionDTO,
} from '../types';

const BASE_URL = 'roadmaps';

export const saveTempo = async (tempo: PostRoadmapTempoDTO) => {
  await api.post(`${BASE_URL}/${tempo.idRoadmap}/tempo`, tempo);
};

export const updateTempo = async (tempo: PostRoadmapTempoDTO) => {
  await api.put(`${BASE_URL}/${tempo.idRoadmap}/tempo`, tempo);
};

export const massEditTempo = async (
  tempos: PostRoadmapMassEditTempoDTO[],
  deletions: RoadmapParticipantDeletionDTO[],
) => {
  await api.put(`${BASE_URL}/tempo/mass`, { tempos, deletions });
};

export const updateTimeRegistry = async (tempos: PostRoadmapTempoDTO[]) => {
  await api.put(`${BASE_URL}/record-time`, tempos);
};

export const getRoadmapTempo = async (roadmapId: number, roadmapStatusId: number | null = null) => {
  return await api.get<GetRoadmapTempoDTO[]>(
    buildURLWithParams(`${BASE_URL}/${roadmapId}/tempo`, {
      roadmapStatusId,
    }),
  );
};

export const getRoadmapsTempo = async () => {
  return await api.get<GetRoadmapTempoDTO[]>(`${BASE_URL}/tempo`);
};

export const getRoadmapsTempoByUser = async (idUser?: number) => {
  return await api.get<GetRoadmapTempoDTO[]>(`${BASE_URL}/${idUser}/tempo-user`);
};

export const deleteRoadmapTempo = async (idRoadmapTempo: number) => {
  await api.delete<GetRoadmapTempoDTO[]>(`${BASE_URL}/${idRoadmapTempo}/tempo`);
};
